import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useLanguage } from '../../contexts/LanguageContext'

function DemoWatermark() {
  const { isDemoUser } = useAuth()
  const { t } = useLanguage()
  
  if (!isDemoUser) return null
  
  return (
    <div className="fixed bottom-4 right-4 z-40 pointer-events-none">
      <div className="bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-700 rounded-lg px-3 py-2 text-xs font-medium text-amber-800 dark:text-amber-200 opacity-70">
        ⚠ Demo Data - Sample Only
      </div>
    </div>
  )
}

export default DemoWatermark